import { ContactFormContent, ContactFormFields } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../../section/Primitive"
import { useEffect, useState } from "react"
import FieldInput from "src/libs/scalars"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"

interface ICFFormProps extends IPrimitiveProps {
    onChange: ( _value: any, field: string ) => void
    value: any
}
export const CFForm = ( {value, onChange, ...props}: ICFFormProps ): JSX.Element[] => {
    const primitive: ContactFormContent = ( props.primitive || {} ) as ContactFormContent
    const [data, setData]               = useState<ContactFormFields>( primitive.fields || {} )
    
    useEffect(() => {
        setData( primitive.fields || {} )
    }, [ primitive.fields ])

    const __onChange = ( value: any, field: string ) => {
        
        console.log( value, field )
        onChange( value, field )
    }
    return [ 
        ...Object.keys( data ).map(( field:keyof ContactFormFields, i ) => {
            const fld: string = data[ field ].field || "" 
            return <div key={ fld } className="container"> 
                <FieldInput 
                    { ...data[ field ] }
                    field={ fld }
                    value={ value[ fld ] }
                    width={ "100%" }
                    height={ 230 }
                    rows={ 5 }
                    minimal
                    isURLHide
                    hideLib
                    vertical={ primitive.isVerticalTitles ? VerticalType.VERTICAL : undefined }  
                    editable 
                    onChange={ __onChange } 
                /> 
            </div>
        })
    ]
}